<template>
	<div class="animated fadeIn">
		
		<div class="row pageinfo">
            <b-col lg="6">
		        <h2>Hauls Without Agreements</h2>
		    </b-col>
        </div>
        
		<div class="card">
		    <div class="card-body">
			    <b-row>       
		        	<b-container services>
						<div class="row">

									<b-col lg="4" class="my-1">
										<div class="input-group mb-3">
											<div class="input-group-prepend">
												<b-form-input v-model="filter" placeholder="Search" />
												<b-btn class="brad-0" :disabled="!filter" @click="filter = ''">Clear</b-btn>
											</div>
										</div>
									</b-col>
						</div> 
		        		<b-row v-if="loadingData">
			              <b-col cols="12" sm="12" md="12" lg="12">
			                 <p class="text-center">
			                   <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
			                 </p>
			              </b-col>
			            </b-row> 
			            <b-table class="animated fadeIn" v-else striped hover bordered 			show-empty
								stacked         ="md"
								:items          ="items"
								:fields         ="fields"
								:current-page   ="currentPage"
								:per-page       ="perPage"
								:filter         ="filter"
								:sort-by.sync   ="sortBy"
								:sort-desc.sync ="sortDesc"
								@filtered       ="onFiltered"
							 	@row-clicked="rowClicked"
                            > 
					
                            <template slot="action" slot-scope="row">
                                <b-button size="sm" @click="create_a(row.item, row.index)" class="mr-1">
                                    Create Agreement
                                </b-button>     
                            </template>

				            <template slot="row-details" slot-scope="row">
				                <b-card>
				                    <ul>
				                      <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
				                    </ul>
				                </b-card>
				            </template>

            			</b-table> 
            			
									<b-row>
										<b-col lg="2" md="2" sm="12" class="my-1 pull-left">
											<div class="input-group mb-3">
												<div class="input-group-prepend"> </div>
												<b-select :options="pageOptions" v-model="perPage" />
											</div>
										</b-col>
										<b-col lg="10" md="10" sm="12" class="my-1 pull-right">
											<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
										</b-col>
									</b-row> 
					</b-container> 
				</b-row>
		    </div>
		</div> 
	</div>
</template>

<script>

    import Vue from 'vue'
    import agreements_service from './agreements_service'
	import moment from 'moment';
	const items = []
	export default {
        name: 'agreements_pending',
        created: function() {
            this.getAll()
        },
		data () {
			return {
				items           : items,
				loadingData     : true,
				currentPage     : 1,
				perPage         : 25,
				totalRows       : items.length,
				pageOptions     : [ 25, 50, 100],
                configTable     : false,
                sortBy          : 'haul_last_date',
                sortDesc        : true,
                filter          : null,
				//
				fields: [
                    { key: 'id', label: 'ID', sortable: true },
					{ key: 'trucking_company', label: 'Trucking Company', sortable: true },
					{ key: 'energy_company', label: 'Energy Company', sortable: true },
					{ key: 'truck_type', label: 'Truck Type', sortable: true },
					{ key: 'load_location', label: 'Load Location', sortable: true },
					{ key: 'unload_location', label: 'Unload Location', sortable: true },
				    { key: 'total',label: 'Hauls', sortable: true },
					{ key: 'haul_last_date',label: 'Haul Last Date', sortable: true },
                    // { key: 'action',label: 'Action'}								
                ],
				role:'',
				energy_company_id :null,

            }
        },
		computed: {
	        sortOptions () {
	            // Create an options list from our fields
	            return this.fieldsTh
	            .filter(f => f.sortable)
	            .map(f => { return { text: f.label, value: f.key } })
	            }
		    },
	    methods: {
	    	onFiltered (filteredItems) {
		    	// Trigger pagination to update the number of buttons/pages due to filtering
		    	this.totalRows = filteredItems.length
		    	this.currentPage = 1
		    },
            create_a(item, index) {
					this.re_item=item       
			},

			rowClicked(row) {   
                console.log('go')
				this.$router.push('/agreement_pending_detail/'+row.id)
			},

            getAll () {
                this.loadingData = true
                agreements_service.getAllPending()
                    .then(data => {
                        if (data.status == 'success') {
					        this.items 		= data.hauls_pending
					        this.role 		= data.role
							console.log(this.items)
                        } else {
                            this.items = []
                            this.$swal(data.status, data.message, data.status)
                        }
                        this.loadingData = false
                    })
                    .catch(error => {
                        this.$swal('Error', 'Server not response. ' + error, 'error')
                        this.loadingData = false
                    })
			},
	    }
	}
</script>


// WEBPACK FOOTER //
// src/views/agreements/agreements_pending.vue